module.exports = __webpack_public_path__ + "img-front/register/kinesis-first.c0331027.svg";